import { StarIcon } from "@phosphor-icons/react";
import { useTranslations } from "use-intl";

import {
  SearchResultButton,
  SearchResultList,
} from "@/components/SearchResultList/SearchResultList";
import type { Airport, City } from "@/types/types";

type Props<T> = {
  topLocations: T[];
  onClick: (location: T) => void;
};

export function TopLocationList<T extends Airport | City>({
  onClick,
  topLocations,
}: Props<T>) {
  const t = useTranslations();

  return (
    <SearchResultList
      heading={t("topLocations")}
      data={topLocations}
      getItemKey={(location) => location.id}
      renderItem={(location) => {
        return (
          <SearchResultButton
            key={location.id}
            icon={StarIcon}
            primaryText={location.name}
            secondaryText={location.countryName}
            code={location.code}
            onClick={() => onClick(location)}
          />
        );
      }}
    />
  );
}
